import { EditFinancialEntity } from "@project/domain/models/financial-entity/edit-financial-entity.model";
import { FinancialEntityFormValuesValidated } from "@project/presentation/components/financial-entity-form/financial-entity-form.component";
import { injectable } from "inversify";
import { EditFinancialEntityBody } from "../../dto/financial-entity/edit-financial-entity.body";

@injectable()
export class EditFinancialEntityMapper {
    mapFromFinancialEntityFormValues(
        financialEntityId: number,
        financialEntityForm: FinancialEntityFormValuesValidated,
    ): EditFinancialEntity {
        return new EditFinancialEntity(
            financialEntityId,
            financialEntityForm.name,
            financialEntityForm.type,
            financialEntityForm.description,
            financialEntityForm.isActive,
            financialEntityForm.entity,
            financialEntityForm.isShared,
            financialEntityForm.sharedWithEntities,
        );
    }

    mapToDto(
        editFinancialEntity: EditFinancialEntity,
    ): EditFinancialEntityBody {
        const body: EditFinancialEntityBody = {
            id: editFinancialEntity.id,
            name: editFinancialEntity.name,
            type: editFinancialEntity.type,
            description: editFinancialEntity.description,
            is_active: editFinancialEntity.isActive,
            entity: editFinancialEntity.entity ?? 0, // fallback seguro, ajusta según lógica de negocio
        };

        if (editFinancialEntity.isShared !== undefined) {
            body.is_shared = editFinancialEntity.isShared;
        }

        if (editFinancialEntity.sharedWithEntities !== undefined) {
            body.shared_with_entities = editFinancialEntity.sharedWithEntities;
        }

        return body;
    }
}
